<template>
  <div class="ts-border ts-p-3 ts-rounded">
    <div class="ts-overflow-y-scroll" style="max-height: 50vh">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th class="ts-text-center" style="width: 1%">
              {{ $t('no') }}
            </th>
            <th style="width: 7%">
              {{ $t('stockIn.barcode') }}
            </th>
            <th style="width: 250px">
              {{ $t('stockIn.productName') }}
            </th>
            <th style="width: 8%">
              {{ $t('stockIn.expireDate') }}
            </th>
            <th class="ts-text-center" style="width: 6%">
              {{ $t('stockIn.uom') }}
            </th>
            <th class="ts-text-center" style="width: 9%">
              {{ $t('stockIn.cost') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('stockIn.qty') }}
            </th>
            <th class="ts-text-center" style="width: 9%">
              {{ $t('stockIn.discount') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('stockIn.discountType') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('stockIn.vatRate') }}
            </th>
            <th class="ts-text-center" style="width: 10%">
              {{ $t('stockIn.amount') }}
            </th>
            <th class="ts-text-center" style="width: 10%">
              {{ $t('stockIn.convertedAmount') }}
            </th>
            <th class="ts-text-center" style="width: 2%" v-if="!isNotAllowUpdate">
              <a href="#" class="ts-text-white" @click.prevent="addNewRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="model.product_details == 0">
            <td colspan="13" class="ts-text-center ts-p-3 ts-space-x-1">
              <i class="fa fa-folder-open ts-text-gray-200"></i>
              <label class="ts-text-gray-400">
                {{ $t('noData') }}
              </label>
              <div class="validate ts-text-left" v-if="errors.has('product_details')">
                {{ errors.first('product_details') }}
              </div>
            </td>
          </tr>
          <tr v-for="(detail, index) in model.product_details" :key="index">
            <td class="ts-text-center">
              {{ index + 1 }}
            </td>
            <td valign="top" class="ts-w-32">
              <input type="text" class="form-control" style="min-width: 50px;" :value="findProduct(detail.product_id)
                ? findProduct(detail.product_id).barcode
                : ''
                " readonly />
            </td>
            <td valign="top">
              <div class="ts-flex">
                <input type="text" :value="findProduct(detail.product_id)
                  ? findProduct(detail.product_id).product_name_en
                  : ''
                  " class="form-control" readonly
                  style="min-width: 200px;border-bottom-right-radius: 0px !important;border-top-right-radius: 0px !important" />
                <a-popover :title="$t('stockIn.serial')" placement="bottomRight">
                  <template slot="content">
                    <div class="scroll">
                      <ul>
                        <b>Total Serial: {{ detail.qty > 1 ? detail.qty : 0 }}</b>
                        <div class="ts-grid ts-grid-cols-2">
                          <li v-for="(s, i) in detail.imei_list" :key="i" class="ts-px-4 ts-whitespace-no-wrap">
                            {{ s }}
                          </li>
                        </div>
                      </ul>
                    </div>
                  </template>
                  <label v-show="findProduct(detail.product_id).require_imei === true" :for="'file_' + index"
                    class="ts-border ts-px-2 ts-py-2 ts-cursor-pointer ts-mb-0" :class="findProduct(detail.product_id).product_name_en
                      ? 'ts-border-green-600'
                      : ''
                      "
                    style="height: 34px;border-top-right-radius: 0.25rem;border-bottom-right-radius: 0.25rem;border-bottom-left-radius: 0px !important;border-top-left-radius: 0px !important">
                    <i class="fas fa-file-excel"></i>
                  </label>
                  <input type="file" :ref="'file_' + index" :id="'file_' + index" class="ts-hidden"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="e => onFileChange(e, detail)" :class="{
                      'is-invalid': errors.has(
                        'product_details.' + index + '.imei_list'
                      )
                    }" />
                </a-popover>
              </div>
              <div class="ts-text-red-600 ts-text-xs" v-if="errors.first('product_details.' + index + '.imei_list')
              ">
                {{ errors.first("product_details." + index + ".imei_list") }}
              </div>
            </td>
            <td valign="top">
              <a-date-picker v-model="detail.expiry_date" :disabled="!detail.is_expire" format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY" style="min-width: 120px" class="ts-w-full" :class="{
                  'is-invalid': errors.has(
                    'product_details.' + index + '.expiry_date'
                  )
                }"></a-date-picker>
              <div class="invalid-feedback" v-if="errors.has('product_details.' + index + '.expiry_date')">
                {{ errors.first('product_details.' + index + '.expiry_date') }}
              </div>
            </td>
            <td valign="top">
              <a-select v-model="detail.uom_id" class="ts-w-full" style="min-width: 70px"
                :options="getUnitOfMeasures(detail.uom_cat_id)" option-filter-prop="children" :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.uom_id')
                }" @change="onUomChange(detail)">
              </a-select>
            </td>
            <td valign="top">
              <ts-currency-converter-input :input_amount.sync="detail.input_cost" :amount.sync="detail.cost"
                :input_currency_id.sync="detail.input_currency_id" :currency_id.sync="detail.currency_id"
                :fx_rate.sync="detail.fx_rate" :fx_rate_ratio.sync="detail.fx_rate_ratio" style="min-width: 120px;" />
              <div class="validate" v-if="errors.has('po_detail.' + index + '.cost')">
                {{ errors.first('po_detail.' + index + '.cost') }}
              </div>
            </td>
            <td valign="top">
              <input v-model.number="detail.qty" :disabled="findProduct(detail.product_id).require_imei === true"
                type="number" ref="qty" @keypress.enter="onQtyEnter(index)" class="form-control ts-text-center" :class="{
                  'is-invalid': errors.has('product_details.' + index + '.qty')
                }" :readonly="isNotAllowUpdate" style="min-width: 80px" />
              <div class="invalid-feedback" v-if="errors.has('product_details.' + index + '.qty')">
                {{ errors.first('product_details.' + index + '.qty') }}
              </div>
            </td>
            <td valign="top">
              <input v-if="detail.discount_type == '%'" ref="discountRate" type="number"
                v-model.number="detail.input_discount_rate" class="form-control" :class="{
                  'is-invalid': errors.has(
                    'po_detail.' + index + '.discount_rate'
                  )
                }" />
              <ts-currency-converter-input v-else :input_amount.sync="detail.input_discount_rate"
                :amount.sync="detail.discount_rate" :input_currency_id.sync="detail.input_currency_id"
                :currency_id.sync="detail.currency_id" :fx_rate.sync="detail.fx_rate"
                :fx_rate_ratio.sync="detail.fx_rate_ratio" style="min-width: 120px;" />
              <div class="invalid-feedback" v-if="errors.has('po_detail.' + index + '.discount_rate')">
                {{ errors.first('po_detail.' + index + '.discount_rate') }}
              </div>
            </td>
            <td valign="top">
              <a-select v-model="detail.discount_type" class="ts-w-full" style="min-width: 50px" :class="{
                'is-invalid': errors.has(
                  'po_detail.' + index + '.discount_type'
                )
              }">
                <a-select-option value="%">%</a-select-option>
                <a-select-option :value="getDiscountCurrency(detail.input_currency_id)">
                  {{ getDiscountCurrency(detail.input_currency_id) }}
                </a-select-option>
              </a-select>
              <div class="invalid-feedback" v-if="errors.has('po_detail.' + index + '.discount_type')">
                {{ errors.first('po_detail.' + index + '.discount_type') }}
              </div>
            </td>
            <td valign="top">
              <input v-model.number="detail.vat_rate" ref="vatRate" type="number" class="form-control ts-text-right"
                :class="{
                  'is-invalid': errors.has(
                    'product_details.' + index + '.vat_rate'
                  )
                }" style="min-width: 80px" :readonly="isNotAllowUpdate" />
              <div class="invalid-feedback" v-if="errors.has('product_details.' + index + '.vat_rate')">
                {{ errors.first('product_details.' + index + '.vat_rate') }}
              </div>
            </td>
            <!-- <td valign="top" class="ts-w-24">
              <select class="form-control"
                v-model="detail.product_grade"
              >
                <option value="">--</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="D">D</option>
              </select>
          </td> -->
            <td valign="top">
              <ts-currency-input v-model.number="detail.input_total_after_discount" class="form-control ts-text-right"
                style="min-width: 120px" :currency="getCurrencySign(detail.input_currency_id)"
                :precision="getPrecision(detail.input_currency_id)" :disabled="true" />
            </td>
            <td valign="top">
              <ts-currency-input v-model.number="detail.total_after_discount" class="form-control ts-text-right"
                style="min-width: 120px" :currency="getCurrencySign(detail.currency_id)"
                :precision="getPrecision(detail.currency_id)" :disabled="true" />
            </td>
            <td class="ts-text-center" valign="middle" v-if="!isNotAllowUpdate">
              <a href="#" class="ts-text-red-600 ts-my-auto" @click.prevent="removeRow(detail)">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total-footer">
            <td colspan="2">
              <b>
                {{ $t('stockIn.numberRow') }} :
                {{ model.product_details.length }}
              </b>
            </td>
            <td colspan="4" class="ts-text-right">
              <b>{{ $t('stockIn.total') }} :</b>
            </td>
            <td>
              <input v-model.number="sumTotalQty" type="number" class="form-control ts-text-center"
                style="min-width: 100px;border:transparent;" readonly />
            </td>
            <td colspan="3"></td>
            <td class="ts-text-right">
              <b>{{ $t('stockIn.total') }} :</b>
            </td>
            <td>
              <ts-currency-input v-model.number="total" class="form-control ts-text-right ts-font-bold"
                style="min-width: 100px;border:transparent;" :currency="defaultCurrency.currency_symbol"
                :precision="defaultCurrency.currency_rounding" :disabled="true" />
            </td>
            <td></td>
          </tr>
          <tr class="total-footer">
            <td class="ts-bg-white" colspan="10" rowspan="2"></td>
            <td class="ts-text-right">
              <b>{{ $t('stockIn.vatAmount') }} :</b>
            </td>
            <td>
              <ts-currency-input v-model.number="vatAmount" class="form-control ts-text-right ts-font-bold"
                style="min-width: 100px;border:transparent;" :currency="defaultCurrency.currency_symbol"
                :precision="defaultCurrency.currency_rounding" :disabled="true" />
            </td>
            <td></td>
          </tr>
          <tr class="total-footer">
            <td class="ts-text-right">
              <b>{{ $t('stockIn.grandTotal') }} :</b>
            </td>
            <td>
              <ts-currency-input v-model.number="grandTotal" class="form-control ts-text-right ts-font-bold "
                style="min-width: 100px;border:transparent;color: red;" :currency="defaultCurrency.currency_symbol"
                :precision="defaultCurrency.currency_rounding" :disabled="true" />
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>

      <!-- modal show pop-up to be able add product -->
      <a-modal v-if="show_modal_add_product" v-model="show_modal_add_product" :footer="null" :zIndex="1020"
        :maskClosable="false" width="800px" :title="$t('stockIn.product')">
        <ProductList v-model="model" />
      </a-modal>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'

export default {
  name: 'itemList',
  props: ['value', 'validate'],
  components: {
    ProductList
  },
  data() {
    return {
      errors: new Errors(),
      show_modal_add_product: false,
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('stock/stockInV2', ['edit_data', 'formViewDatas']),
    products() {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products']
      }
      return []
    },
    unitOfMeasures() {
      if (this.formViewDatas['unitOfMeasures']) {
        return this.formViewDatas['unitOfMeasures'].map(el => ({
          value: el.uom_id,
          label: el.uom_name_en,
          uom_cat_id: el.uom_cat_id,
          is_default: el.is_default,
          stockout_quantity: el.stockout_quantity
        }))
      }
      return []
    },
    defaultCurrency() {
      if (this.formViewDatas['currency']) {
        return this.formViewDatas['currency'].find(el => el.is_default == true)
      }
      return {
        currency_symbol: '',
        currency_rounding: null
      }
    },
    isNotAllowUpdate() {
      return (
        !_.isEmpty(this.edit_data) &&
        (this.edit_data ? this.edit_data.is_confirm_stock : false)
      )
    },
    total() {
      return _.sumBy(this.model.product_details, function (o) {
        return o.total_after_discount
      })
    },
    vatAmount() {
      return _.sumBy(this.model.product_details, function (o) {
        return o.vat_amount
      })
    },
    grandTotal() {
      return _.sumBy(this.model.product_details, function (o) {
        return o.grand_total
      })
    },
    sumTotalQty() {
      return _.sumBy(this.model.product_details, 'qty')
    },
  },
  methods: {
    findProduct(product_id) {
      return this.products.find(el => el.product_id == product_id)
    },
    getUnitOfMeasures(uom_cat_id) {
      return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
    },
    getDiscountCurrency(input_currency_id) {
      if (this.formViewDatas['currency']) {
        return this.formViewDatas['currency'].find(
          el => el.currency_id == input_currency_id
        ).currency_symbol
      }
      return null
    },
    getCurrencySign(currency_id) {
      if (this.formViewDatas['currency']) {
        const currency = this.formViewDatas['currency'].find(
          el => el.currency_id == currency_id
        )
        return currency ? currency.currency_symbol : null
      }
      return null
    },
    getPrecision(currency_id) {
      if (this.formViewDatas['currency']) {
        const currency = this.formViewDatas['currency'].find(
          el => el.currency_id == currency_id
        )
        return currency ? currency.currency_rounding : null
      }
      return null
    },
    addNewRow() {
      this.show_modal_add_product = true
    },
    removeRow(row) {
      this.model.product_details.splice(
        this.model.product_details.indexOf(row),
        1
      )
    },
    onUomChange(row) {
      const product = this.products.find(el => el.product_id == row.product_id)
      const price = product.sale_code.find(el => el.uom_id == row.uom_id)

      row.cost = price ? price.cost : 0
      row.input_cost = price ? price.cost : 0
      row.input_currency_id = row.currency_id
    },
    calculate() {
      this.model.product_details.forEach(el => {
        // Handle percentage-based discount
        if (el.discount_type === '%') {
          el.discount_rate = el.input_discount_rate;
          const input_discount = (el.input_cost * el.qty * el.input_discount_rate) / 100;
          el.input_total_after_discount = el.input_cost * el.qty - input_discount;
        } else {
          // Handle flat discount
          el.discount_type = this.getDiscountCurrency(el.input_currency_id);
          el.discount_rate = el.input_discount_rate * el.fx_rate_ratio;
          el.input_total_after_discount = el.input_cost * el.qty - el.input_discount_rate;
        }

        const uom = this.unitOfMeasures.find(uom => uom.value == el.uom_id)

        el.stock_quantity = uom.stockout_quantity * el.qty;

        // Common calculations for both discount types
        const calculateWithFxRate = (value) => value * el.fx_rate_ratio;

        // Calculate total after discount with exchange rate
        el.total_after_discount = calculateWithFxRate(el.input_total_after_discount);

        // Calculate VAT
        el.input_vat_amount = el.input_total_after_discount * (el.vat_rate / 100);
        el.vat_amount = calculateWithFxRate(el.input_vat_amount);

        // Calculate grand total
        el.input_grand_total = el.input_total_after_discount + el.input_vat_amount;
        el.grand_total = calculateWithFxRate(el.input_grand_total);
      });

      this.model.invoice_amount = _.sumBy(this.model.product_details, function (el) {
        return el.grand_total
      })
    },
    onFileChange(e, product) {
      var file = e.target.files[0]
      var fileName = file.name
      if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) {
        // product.label = fileName
        var reader = new FileReader()
        reader.onload = e => {
          var data = new Uint8Array(e.target.result)
          var workbook = this.readExcelData(data)

          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          product.imei_list = this.parseWorksheetData(worksheet).flatMap(el => Object.values(el))
          product.qty = product.imei_list.length
        }
        reader.readAsArrayBuffer(file)
        return
      }
      this.$toasted.error('Not a valid Excel file')
    },
    readExcelData(data) {
      var arr = new Array()
      for (var i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i])
      }
      var bstr = arr.join('')
      return XLSX.read(bstr, { type: 'binary' })
    },
    parseWorksheetData(worksheet) {
      var jsonData = []
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        const row = {}
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: 0 })
          const cell = worksheet[cellAddress]

          if (cell) {
            row = cell.v
          }
        }
        if (Object.keys(row).length) {
          jsonData.push({ 0: row });
        }
      }
      return jsonData
    }
  },
  watch: {
    'model.product_details': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  opacity: 1;
}

.py {
  padding: 0.45rem 0;
}

.max-h {
  min-height: 30vh;
  max-height: 50vh;
}

table {
  position: relative;
  border-collapse: collapse;
}

table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
  text-transform: uppercase;
  border-width: 1px;
  white-space: nowrap;
}

table tbody tr td {
  padding: 4px 5px;
  border-width: 1px;
}

table tfoot tr {
  background-color: #e3e8f1;
  border-width: 1px;
}

table tfoot tr td {
  padding: 0 5px;
  white-space: nowrap;
  border: 1px solid white;
}

.total-footer .form-control {
  font-weight: 900;
}
</style>